import appendChildAtIndex from './append/appendChildAtIndex';
import prependChild from './prepend/prependChild';
import prependChildAtIndex from './prepend/prependChildAtIndex';

// ----------------------------------------------------------------------------

export type TypeContainer = {
    parent?: Node;
    prepend?: boolean;
    index?: number;
};

export type TypeResolvedContainer = TypeContainer & {
    parent: Node;
};

// ----------------------------------------------------------------------------

function container(element: HTMLElement, config?: TypeContainer): void {
    const defConfig: TypeResolvedContainer = {
        parent: document,
        ...config,
    };

    const index = defConfig.index;
    const hasValidIndex = typeof index === 'number' && Number.isInteger(index) && index >= 0;

    if (defConfig.prepend === true) {
        if (hasValidIndex) {
            prependChildAtIndex(defConfig.parent, element, index);
        } else {
            prependChild(defConfig.parent, element);
        }

        return;
    }

    if (hasValidIndex) {
        appendChildAtIndex(defConfig.parent, element, index);
    } else {
        defConfig.parent.appendChild(element);
    }
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        container(config?: TypeContainer): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.container = function (config?: TypeContainer): HTMLElement {
    container(this, config);

    return this;
};

// ----------------------------------------------------------------------------

export default container;
